import * as THREE from "three";
import Experience from "./Experience";
import { CSS3DRenderer } from "three/examples/jsm/Addons.js";

export default class Renderer {
    constructor() {
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.scene = this.experience.scene
        this.camera = this.experience.camera.instance
        this.sizes = this.experience.sizes

        this.setInstance()
    }

    setInstance() {
        this.instance = new THREE.WebGLRenderer({
            alpha: true, // 允许透明背景
            antialias: true,
            powerPreference: 'high-performance', // 优先使用高性能GPU
        })

        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))
        this.instance.outputEncoding = THREE.sRGBEncoding

        // this.instance.toneMapping = THREE.ACESFilmicToneMapping
        // this.instance.toneMappingExposure = 1.75
        // this.instance.shadowMap.enabled = true
        // this.instance.shadowMap.type = THREE.PCFSoftShadowMap
        // this.instance.setClearColor('#211d20')
        // this.instance.physicallyCorrectLights = true;

        document.querySelector('#webgl').appendChild(this.instance.domElement);
        // this.instance.domElement.style.pointerEvents = 'none'; // 禁用鼠标事件，避免干扰其他交互

        this.cssInstance = new CSS3DRenderer({
            antialias: true,
            alpha: true, // 允许透明背景
        });
        this.cssInstance.setSize(this.sizes.width, this.sizes.height);
        this.cssInstance.domElement.style.position = 'absolute';
        this.cssInstance.domElement.style.top = '0px';

        document.querySelector('#css').appendChild(this.cssInstance.domElement);
        

    }

    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2))
        // this.camera.aspect = this.sizes.width / this.sizes.height
        // this.camera.updateProjectionMatrix()

        this.cssInstance.setSize(this.sizes.width, this.sizes.height);

    }

    update() {

        this.instance.render(this.scene, this.camera)
        this.cssInstance.render(this.experience.cssScene, this.camera);

        // CSS3D渲染器降频更新
        // if (!this.lastCSS3DRender || Date.now() - this.lastCSS3DRender > 16) { // 约60FPS
            
            
        //     this.lastCSS3DRender = Date.now();
        // }
        // this.cssInstance.render(this.experience.cssScene, this.camera);
    }
}